import {Component, OnInit, ViewChild} from '@angular/core';
import { ApiClientService } from '../../../../services/api-client.service';
import { AuthenticationService } from '../../../../services/authentication.service';
import { UrlService } from '../../../../services/url.service';
import { NgForm } from '@angular/forms';
import { ConstantsService } from '../../../../services/constants.service';
import { PropertyService } from '../services/property.service';
import { ResidentService } from '../../../../services/resident.service';


declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'set-contact-us-modal',
    templateUrl: './set-contact-us-modal.component.html',
    styleUrls: ['./set-contact-us-modal.component.scss']
})
export class SetContactUsModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    disabledSubmit = false;
    showEditPanel = false;
    contactUs = '';
    originalContactUs = '';

    constructor(
        public api: ApiClientService,
        public propertyService: PropertyService,
        public authService: AuthenticationService,
        public urlService: UrlService,
        public residentService: ResidentService
    ) {}

    ngOnInit() {
        this.initData();
        setTimeout( () => this.showModal = true, 300);
    }

    initData() {
        if(this.propertyService.selectedBuilding) {
            this.originalContactUs = this.propertyService.selectedBuilding.contactUs ? this.propertyService.selectedBuilding.contactUs.slice() : '';
            this.contactUs = this.originalContactUs;
        }
    }

    hideModal() {
        if (this.showEditPanel) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                this.residentService.getBuildingsInfo();
                    this.propertyService.contactUsModalShow = false;
                }
            );
        } else {
            this.residentService.getBuildingsInfo();
            this.propertyService.contactUsModalShow = false;
        }
    }

    onSubmit(skipCheck?) {
        if(!skipCheck) {
            if (this.contactUs == '' || (this.contactUs.replace(/&nbsp;/g, '')).replace(/\s/g, '').replace(/<br>/g, '') == '') {
                toastr.warning('Contact info should not be blank.');
                return;
            }
        }

        const data = {
            contactUs : this.contactUs
        };
        this.disabledSubmit = true;
        this.propertyService.updateBuildingInfo(data).subscribe(
             () => this.propertyService.contactUsModalShow = false,
             () => this.disabledSubmit = false
        );
    }

    initSummernote(id) {
        const summernote = $(id);
        summernote.summernote({
            dialogsInBody: true,
            callbacks: { onChange: contents => this.contactUs = contents },
            toolbar: [
                ['style', ['style']],
                ['fontsize', ['fontsize']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'hr']],
                ['help', ['help']]
            ],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true
        });
        $('.note-btn-bold').removeClass('active');
        $('.note-editable').html(this.contactUs).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
        $('.note-editable').html(this.contactUs).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
    }

    showEditPanelSetter(): void {
        this.showEditPanel = true;
        setTimeout( () => this.initSummernote('#summernote'), 300);
    }

    closeEditPanel() {
        this.showEditPanel = false;
        this.contactUs = this.originalContactUs;
    }

    deleteContactUsInfo() {
        this.contactUs = '';
        this.onSubmit(true);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/set-contact-us-modal/set-contact-us-modal.component.ts